import React from "react";
import { Card, CardHeader, CardBody, CardTitle, CardText, Badge, Row, Col } from "reactstrap";
import { extractTierFromName, getAvailabilityStatusClass, getProductTierBadgeColor } from "../../../../../utility/inventoryUtils";
import './index.css'
import { ProductSummary } from "../../../../../hooks/useFirebaseProductSummaries";

interface ByChannelTabProps {
  productSummaries: ProductSummary[];
}

export const ByChannelTab: React.FC<ByChannelTabProps> = ({ productSummaries }) => {

  if (!productSummaries || productSummaries.length === 0) {
    return (
      <div className="text-center py-5">
        <div className="alert alert-warning">
          <h5>No product data available</h5>
          <p className="mb-0">No product summaries data found. Please check if data exists in Firebase.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="inventory-by-channel-tab-content">
      {productSummaries.map((product) => {
        const tier = extractTierFromName(product.displayName);

        return (
          <Card key={product.id} className="inventory-channel-card mb-3">
            <CardHeader className="inventory-channel-card-header">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <CardTitle className="inventory-channel-product-name h6 mb-1">
                    {product.displayName}
                  </CardTitle>
                  <CardText className="inventory-channel-product-sku text-muted small mb-0">
                  {product.productId || "No Product ID"}
                  </CardText>
                </div>
                <div>
                  <Badge
                    color={getProductTierBadgeColor(tier)}
                    className="inventory-channel-tier-badge me-2"
                  >
                    {tier}
                  </Badge>
                  <Badge color="info" className="inventory-channel-count-badge">
                    {Object.keys(product.channels || {}).length} Channels
                  </Badge>
                </div>
              </div>
            </CardHeader>
            <CardBody className="inventory-channel-card-body">
              <Row>
                {Object.entries(product.channels || {}).map(([channelName, channel]) => {
                  const allocated = channel.allocated || 0;
                  const orders = channel.reserved || 0;
                  const available = channel.available || 0;

                  return (
                    <Col md={3} key={channelName} className="mb-3">
                      <div className="inventory-channel-detail-card p-3 rounded border">
                        <div className="inventory-channel-name small fw-bold text-muted mb-2 text-uppercase">
                          {channelName}
                        </div>
                        <div className="inventory-channel-metrics">
                          <div className="inventory-channel-metric d-flex justify-content-between small mb-2">
                            <span className="text-muted">Allocated:</span>
                            <span className="fw-bold text-primary">{allocated}</span>
                          </div>
                          <div className="inventory-channel-metric d-flex justify-content-between small mb-2">
                            <span className="text-muted">Orders:</span>
                            <span className="fw-bold text-warning">{orders}</span>
                          </div>
                          <div className="inventory-channel-metric d-flex justify-content-between small mb-2">
                            <span className="text-muted">Available:</span>
                            <span className={`fw-bold ${getAvailabilityStatusClass(available)}`}>
                              {available}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </CardBody>
          </Card>
        );
      })}
    </div>
  );
};